import { SET_FEATURE_CONTROL, UPDATE_FEATURE_CONTROLS } from './actionTypes';
/**
 * Sets a single feature control toggle.
 *
 * @param {string} feature - The feature key.
 * @param {boolean} enabled - Whether the feature is enabled.
 * @returns {Object}
 */
export function setFeatureControl(feature, enabled) {
    return {
        type: SET_FEATURE_CONTROL,
        feature,
        enabled
    };
}
/**
 * Updates all feature controls at once (used for metadata sync).
 *
 * @param {Record<string, boolean>} featureControls - The feature controls map.
 * @returns {Object}
 */
export function updateFeatureControls(featureControls) {
    return {
        type: UPDATE_FEATURE_CONTROLS,
        featureControls
    };
}
